import React, { useState, useEffect } from 'react';
import '../App.css';
import axios from "axios";
import { Form, Row } from 'react-bootstrap';
//import {  Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

// import Navbar from "./Navbar_vecchio";
// import DatePicker from "react-datepicker";
// import Crea_nuovo_alunno from "./Alunno_x0_1_crea_alunno";

import { useAuth0 } from "@auth0/auth0-react";
import JSONPretty from 'react-json-pretty';
import Seleziona_la_classe from "./Alunno_x3_seleziona_classe.jsx";
import Lista_alunni from "./Alunno_x4_lista_alunni.jsx";


function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }

const Gestione_Alunno = (props) => {
    const [input, setInput] = useState({
        nome: '',
        cognome: '',
        email: '',
        email_genitore: ''

    });
    const [lista_alunni, SET_lista_alunni] = useState([]);
    const [lista_classi, SET_lista_classi] = useState([]);
    const [tutor, SET_tutor] = useState('');
    const [classe_selezionata, SET_classe_selezionata] = useState();
    const [cestino, SET_cestino] = useState(false);

    const [variab_aggiorna, SET_variab_aggiorna] = useState(false);
    const [end_Date, set_End_Date] = useState(new Date());
    const { user, isAuthenticated } = useAuth0();


    useEffect(() => {
        let btn 
        
        btn = check_variabili_oggetto (user, 'email')
//        console.log(btn)
//        console.log(user)
  
        if (btn !== undefined) { 
            Controlla_se_esiste_Account()
        }
        if (user != undefined && user.email != undefined) {
            Carica_alunni_x_account(cestino)
        }
//        Carica_alunni_x_account_vecchio()
    }, [variab_aggiorna, user, classe_selezionata]);


    const Controlla_se_esiste_Account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('XXXXXXXXXXXXXXX Carica_tutor_x_account')
        console.log(user.email)
     
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        
        axios.get('/tutor/cerca1/' + user.email)
            .then((res) => {
                console.log('un TUTOR appena fecciato da mongo')
                console.log(res.data)

                // idroslab gli account restituiti sono comunque una lista
                console.log(check_variabili_oggetto (res.data[0], '_id'))
                Carica_classi_x_account(check_variabili_oggetto (res.data[0], '_id'))
                SET_classe_selezionata(res.data[0].ultima_classe_selezionata)
                SET_tutor(res.data[0])
            }).catch((error) => {
                console.log(error)
            });
    }


    const Carica_classi_x_account = (_id) => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_classi')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/classi/classi5/' + utente + '/' + _id)
            .then((res) => {
//                console.log('CLASSI X TUTOR appena fecciate da mongo')
//                console.log(res.data)
                if (Array.isArray(res.data) && res.data.length > 0) {SET_lista_classi(res.data)}
            }).catch((error) => {
                console.log(error)
            }); 
    }


    const Carica_alunni_x_account_vecchio = (parametro_cestino) => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_alunni x_account ' + parametro_cestino)
     
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        console.log('------------------- ' + classe_selezionata)
        axios.get('/alunni/alunni2/' 
                       + utente + '/' + classe_selezionata + '/' + user.email + '/' + parametro_cestino)
            .then((res) => {
//                console.log('ALUNNI appena fecciate da mongo')
                console.log(res.data)
                SET_lista_alunni(res.data)
            }).catch((error) => {
                console.log('ALUNNI errore')
                console.log(error)
            });
    }


    const Carica_alunni_x_account = (parametro_cestino) => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_alunni x_account ' + parametro_cestino)
     
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        console.log('classe_id ' + classe_selezionata)


        axios.get('/alunni/alunni_nuovo/', {
            params: {
                utente: utente,
                classe_id: classe_selezionata,
                email: user.email, 
                cestino: parametro_cestino,
            }
        }).then((res) => {
//                console.log('ALUNNI appena fecciate da mongo')
            console.log(res.data)
            SET_lista_alunni(res.data)
        }).catch((error) => {
            console.log('ALUNNI errore')
            console.log(error)
        });
    }





    function handleChange(event) {
        const { name, value } = event.target;
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }

    function handleClick(event) {
        event.preventDefault();
        const nuovo_alunno = { 
            nome: input.nome,
            cognome: input.cognome,

            email: input.email,
            classe_id: classe_selezionata
        }

        console.log(input);
        axios.post('/alunni/salva_nuovo', nuovo_alunno)
        .then((res) => {
            //                console.log('Aggiunta una classe')
            SET_variab_aggiorna(current => !current)
         }).catch((error) => {
            console.log('Cancella')

        });
    }



    function Mostra_alert(item) {
        if (item.classe_id !== undefined) {
            if (item.classe_id.nome !== undefined) {
                return <>
                <Row><p>classe: <strong>{item.classe_id.nome}</strong></p></Row>
                </>
            }
        }
    }

    function handleChange2(event) {
        const { name, value, type } = event.target;
        console.log('cestino attuale: ' + cestino)
        Carica_alunni_x_account(!cestino)
        SET_cestino(current => !current)
    }
        

    return (
        <div className='container'>
            
            {user != undefined && user.email === 'paolosordi12@gmail.com' && <Form.Check // prettier-ignore
                    type='checkbox'
                    name='Cestino' 
                    onChange={handleChange2}  
                    checked = {cestino}                  
                    label={`Visualizza alunni nel cestino`}
                />}
            {/*console.log(lista_ditte)*/}


            {(props.account_dati.utente_debug) &&
                <JSONPretty data={user} />
            }
            {(props.account_dati.utente_debug) &&
                <JSONPretty data={tutor} />
            }
            <div className='container'>
                <div className= 'd-flex flex-row-reverse'>
                    
                    <Seleziona_la_classe    lista_classi={lista_classi} 
                                            SET_classe_selezionata ={SET_classe_selezionata}
                                            classe_selezionata={classe_selezionata} 
                                            tutor ={tutor}
                                            />
                </div>
                <div className= 'd-flex flex-row-reverse'>
                        <p>{check_variabili_oggetto (tutor, 'email')}</p>
                </div>
                <h1>Inserisci nuovo Alunno </h1>
                <form>
                    <div className='form-group'>
                        <input onChange={handleChange} name="nome" placeholder="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                    </div>
                    <div className='form-group'>
                        <input onChange={handleChange} name="cognome" placeholder="cognome" value={input.cognome} autoComplete="off" className="form-control"></input>
                    </div>
                    <div className='form-group'>
                        <input onChange={handleChange} name="email" placeholder="email" value={input.email} autoComplete="off" className="form-control"></input>
                    </div>

                    <div class="d-flex flex-row-reverse">
                        <button onClick={handleClick} className="btn btn-lg btn-info">Salva</button>
                    </div>
                </form>
            </div>

            <Lista_alunni account_dati={props.account_dati}

                variab_aggiorna ={variab_aggiorna} 
                SET_variab_aggiorna={SET_variab_aggiorna} 
                tutor={tutor} lista_alunni={lista_alunni}
                lista_classi={lista_classi}
            />

        </div >
    )
}

export default Gestione_Alunno;
